import { MessageCircle, Instagram, Mail } from "lucide-react";
import { motion } from "framer-motion";
import {
  whatsappLink,
  instagramLink,
  gmailLink,
} from "../lib/contact";

export const FloatingButtons = () => {
  return (
    <div
      data-testid="floating-buttons"
      className="fixed right-4 sm:right-6 bottom-6 z-40 flex flex-col gap-3"
    >
      <motion.a
        data-testid="fab-whatsapp"
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.5 }}
        className="fab bg-[rgb(182,245,0)] lime-glow-strong"
        title="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6 text-black" strokeWidth={2.4} />
      </motion.a>
      <motion.a
        data-testid="fab-instagram"
        href={instagramLink()}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.6 }}
        className="fab bg-black border border-[rgba(182,245,0,0.5)]"
        title="DM on Instagram"
      >
        <Instagram className="w-5 h-5 text-[rgb(182,245,0)]" strokeWidth={2.2} />
      </motion.a>
      <motion.a
        data-testid="fab-email"
        href={gmailLink()}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.7 }}
        className="fab bg-black border border-[rgba(182,245,0,0.5)]"
        title="Email us"
      >
        <Mail className="w-5 h-5 text-[rgb(182,245,0)]" strokeWidth={2.2} />
      </motion.a>
    </div>
  );
};
